import { render, staticRenderFns } from "./recreateRequest-ant.vue?vue&type=template&id=77756946&scoped=true"
import script from "./recreateRequest-ant.vue?vue&type=script&lang=js"
export * from "./recreateRequest-ant.vue?vue&type=script&lang=js"
import style0 from "./recreateRequest-ant.vue?vue&type=style&index=0&id=77756946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77756946",
  null
  
)

export default component.exports